import { __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
let DateTimeHelper = class DateTimeHelper {
    static parseISO(date) {
        return DateTime.fromISO(date).toISO({
            suppressMilliseconds: true,
        });
    }
    static parseFormat(date, format) {
        return DateTime.fromFormat(date, format);
    }
    static toUtc(date) {
        if (!date || !(date instanceof Date))
            return date;
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const millis = date.getMilliseconds();
        return new Date(Date.UTC(year, month, day, hours, minutes, seconds, millis));
    }
    static fromUtc(date) {
        if (!date || !(date instanceof Date))
            return date;
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth();
        const day = date.getUTCDate();
        const hours = date.getUTCHours();
        const minutes = date.getUTCMinutes();
        const seconds = date.getUTCSeconds();
        const millis = date.getUTCMilliseconds();
        return new Date(year, month, day, hours, minutes, seconds, millis);
    }
};
/**
 * Acceptable by backend server ISO format
 * It's a bit different from moment.js ISO format
 * @type {string}
 */
DateTimeHelper.ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ssZZ";
DateTimeHelper = __decorate([
    Injectable()
], DateTimeHelper);
export { DateTimeHelper };
